import { createAutoCorrectedDatePipe } from 'text-mask-addons';

import { generateMaskedInput } from '../mask';
import { format, mask, placeholderChar, placeholder } from './constants';

const timeWithoutSecondsMask = generateMaskedInput({
  mask,
  pipe: createAutoCorrectedDatePipe(format),
  placeholderChar,
  guide: true,
  keepCharPositions: true,
  placeholder,
});

export * from './tools';
export { timeWithoutSecondsMask };
